import { FC, PropsWithChildren } from 'react';
import LoadingScreen from '../../component/atoms/LoadingScreen';
import UserContext from '../context/user.context';
import useAuthUser from '../hook/auth-user.hook';

const UserContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user, landlordProfile, tenantProfile, activeUserType, isLoadingProfile } = useAuthUser();

  if (isLoadingProfile) {
    return <LoadingScreen />;
  }

  return (
    <UserContext.Provider
      value={{
        user,
        tenantProfile,
        landlordProfile,
        activeUserType,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
